import { BnccExamSessionsTableContainer, BnccExamPerformanceByAreaChartContainer } from "home/components/bncc_exam/containers"
import { BnccExamSessionsTablePresentation, BnccExamPerformanceByAreaChartPresentation } from "home/components/bncc_exam/presentations"

export { BnccExamSessionsTableContainer, BnccExamPerformanceByAreaChartContainer, BnccExamSessionsTablePresentation, BnccExamPerformanceByAreaChartPresentation }
